<template>
  <div class="shipping-btn">
    <TooltipWidget tip="Transportes" left>
      <v-btn
        target="_blank"
        href="https://www.daltrotransporte.com.br/"
        class="text-none"
        fab
        color="primary"
      >
        <v-icon color="#fff" size="23">fas fa-shipping-fast</v-icon>
      </v-btn>
    </TooltipWidget>
  </div>
</template>

<script>
import TooltipWidget from "./TooltipWidget.vue";
export default {
  components: { TooltipWidget },
};
</script>

<style lang="scss" scoped>
.shipping-btn {
  position: fixed;
  right: 16px;
  bottom: 80px;
  width: max-content;
  z-index: 99999;
}
</style>
